<template>
  <div class="container">
    <van-nav-bar
      :title="title"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="box">
      <p v-html="objDetail"></p>
    </div>
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Toast,Loading} from 'vant';
  export default {
    data() {
      return {
        rowId:'',
        title:'',
        objDetail:'',
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
    },
    methods: {
      changePage(item,url){
        this.$router.push({path: url+".html",query:{iccard:item}})
      },
      getUrlParam (name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        let r = (window.location.search.substr(1) || window.location.hash.split('?')[1])['match'](reg)
        if (r != null) return decodeURI(unescape(r[2]))
        else return null
      },
      onSubmit(values) {
        console.log('submit', values);
      },
      getDetail(){
        axios.get("/techsupport/getnoticedetailbyid?id="+this.rowId,{
        }).then((res)=>{
          this.title = res.data.title;
          this.objDetail = res.data.content;
        })
      },
      onClickLeft() {
        this.$router.go(-1);
      },
    },
    computed:{
    },
    created () {
      this.rowId = this.$route.query.rowId;
      this.getDetail();
    },
    mounted () {},
    destroyed () {}
  }
</script>

<style lang="less"> 
  @import "../assets/css/default.less";
  [v-cloak]{ 
    display:none !important;
  }
</style>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #fff}
  .container{
    width: 100%;min-height: 100vh;letter-spacing:0px;background: #fff;
  }
  .box{
    padding: 15px;
    box-sizing: border-box;
    /deep/img{width: 100%;}
    /deep/.ql-align-center{text-align: center;}
  }
  .title{
    display: flex;
    line-height: 30px;
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 30px;
  }
  .title .text{
      width: 80%;
  }
  .wen{
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    margin-right: 16px;
    text-align: center;
    color: #fff;
    border-radius: 8px;
    background: #FDCF84;
  }
  .msgbox{
    display: flex;
  }
  .msgbox .text{
    font-size: 14px;
    line-height: 30px;
    width: 80%;
  }
  .bg_blue{background: #5B92FD;}
</style>
